export default "__VITE_ASSET__DEuw6tBg__"